export type RiskGroupProductBlock<T> = {
  riskGroupID: number | null;
  products: T[];
};

export const groupProductBlocksByRiskGroup = <T extends { risk_group_id?: number | null }>(products: T[]): RiskGroupProductBlock<T>[] => {
  const ordered = groupProductsByRiskGroup(products);
  const blocks: RiskGroupProductBlock<T>[] = [];

  for (const product of ordered) {
    const riskGroupID = product.risk_group_id || null;
    const current = blocks[blocks.length - 1];
    if (riskGroupID && current?.riskGroupID === riskGroupID) {
      current.products.push(product);
    } else {
      blocks.push({ riskGroupID, products: [product] });
    }
  }

  return blocks;
};

export const groupProductsByRiskGroup = <T extends { risk_group_id?: number | null }>(products: T[]): T[] => {
  const groupedRiskIDs = new Set<number>();
  const result: T[] = [];

  for (const product of products) {
    const riskGroupID = product.risk_group_id;
    if (!riskGroupID) {
      result.push(product);
      continue;
    }
    if (groupedRiskIDs.has(riskGroupID)) continue;

    groupedRiskIDs.add(riskGroupID);
    result.push(...products.filter((item) => item.risk_group_id === riskGroupID));
  }

  return result;
};
